import WithRender from "../../templates/layouts/layoutPersonalizationConfiguration.html";

export default WithRender({});
